import type { Config } from '@form-factory/config';

export type ConfigType = {
  debug: boolean;
};

const envConfig =
  __FF_CONFIG__ as any as Config['app']['adminApp']['webConfig'] & {
    debug: boolean;
    version: string;
  };

export const AppSettings = {
  ...envConfig,
  debug:
    import.meta.env.DEV ||
    document.cookie.includes('debug=true') ||
    envConfig.debug,
};
